import { GraphQLClient } from 'graphql-request'

export default {
  async request(...args) {
    return new GraphQLClient(process.env.VUE_APP_API + '/graphql').request(...args)
  },
}
